import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { apiInstance } from "../../../helpers/axios";
import SEO from "../../../components/seo";
import LayoutTwo from "../../../layouts/LayoutTwo";
import CategoryItem from "../CategoryItem";
import LoadingScreen from "../../../components/loading/LoadingScreen";
import noDataImg from "../../../assets/images/no-data-icon.png";
import { useFetchData } from "../../../helpers/api";
import Cookies from "js-cookie";
import lockIcon from "../../../assets/images/lock-icon.png";
import ShopTopActionFilter from "../../../components/product/Filters/ShopTopActionFilter";
import FilterModal from "../../../components/product/Filters/FilterModal";
import toast from "react-hot-toast";

const pageSize = 18;
const theKey = Cookies.get("kalista-webtoken");
const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const theKeyId = customerData?.Id ? customerData.Id : null;

const Collection = () => {
  const { id } = useParams();
  const [isLoadingData, setLoadingData] = useState(true);
  const [isFetchingMore, setFetchingMore] = useState(false);
  const [pageOffSet, setPageOffSet] = useState(1);
  const [sortOrder, setSortOrder] = useState(1);
  const [productData, setProductData] = useState([]);
  const [productGram, setProductGram] = useState([0, 250]);
  const [productCarat, setProductCarat] = useState([0, 100]);
  const [filterModal, setFilterModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [sendCustomData, setSendCustomData] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(
    id ? [String(id)] : []
  );
  const [customFilterData, setCustomFilterData] = useState([
    {
      Id: 0,
      Shape: "ROUND",
      Size: "",
      Weight: "",
      Pcs: "",
      SizeCode: "",
      CustomerId: Number(theKeyId),
    },
  ]);
  const isResetInProgress = useRef(false);

  const { data: singleOrderData, isLoading } = useFetchData(
    ["totalProductsCountCollection", selectedCategory, selectedCollection],
    "/Customer/TotalProducts",
    { DesgGroupNo: selectedCollection, GrpNo: null },
    null,
    { staleTime: 5 * 60 * 1000 }
  );

  const totalProducts = singleOrderData?.Data || 50;
  const grpNO = productData[0]?.GrpNo || 0;

  const { data: prductSizeData, isLoadingSize } = useFetchData(
    ["collectionPrductSizes", selectedCategory, selectedCollection],
    "/Customer/GetItemSize",
    { CategoryId: grpNO },
    grpNO,
    { staleTime: 5 * 60 * 1000, enabled: grpNO !== 0 }
  );

  const getProducts = useCallback(
    async (resetData = null, status = false) => {
      if (productData.length >= totalProducts) return;

      setLoadingData(true);
      setFetchingMore(true);
      setFilterModal(false);

      const hasValidSize =
        customFilterData.length > 0 &&
        customFilterData.some((item) => item.Size !== "");

      const data = resetData ?? {
        DesgGroupNo: selectedCollection,
        CurrentPage: pageOffSet,
        PageSize: pageSize,
        SortOrder: sortOrder,
        Status: "All",
        NetWtFrom: productGram[0],
        NetWtTo: productGram[1],
        DiamondWtFrom: productCarat[0],
        DiamondWtTo: productCarat[1],
        ...(selectedCategory !== "" && {
          CategoryId: Number(selectedCategory),
        }),
        ...(status && hasValidSize ? { customFilterData } : {}),
      };

      try {
        const response = await apiInstance.post(
          "/Customer/getProductList",
          data
        );

        if (response?.status === 200 && Array.isArray(response?.data?.Data)) {
          setProductData((prevData) => [
            ...(prevData || []),
            ...(response.data?.Data || []),
          ]);
        } else {
          toast.error(response.data.Message || "Something went wrong!");
          throw new Error(response.data.Message || "Something went wrong!");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingData(false);
        setFetchingMore(false);
      }
    },
    // eslint-disable-next-line
    [
      id,
      pageOffSet,
      isFetchingMore,
      sortOrder,
      productGram,
      productCarat,
      selectedCategory,
      selectedCollection,
      customFilterData,
    ]
  );

  useEffect(() => {
    setProductData([]);
    setPageOffSet(1);
  }, [id, sortOrder]);

  useEffect(() => {
    setSortOrder(1);
    setProductGram([0, 250]);
    setProductCarat([0, 100]);
    setSelectedCollection((prev) =>
      id && prev[0] !== String(id) ? [String(id)] : prev
    );
  }, [id]);

  useEffect(() => {
    if (selectedCategory !== "") {
      getProducts();
    }
    // eslint-disable-next-line
  }, [selectedCategory]);

  useEffect(() => {
    if (selectedCollection.length > 0 && !isResetInProgress.current) {
      if (sendCustomData) {
        if (pageOffSet > 1) {
          getProducts(null, true);
        } else {
          return;
        }
      } else {
        getProducts();
      }
    } else if (pageOffSet > 1) {
      getProducts();
    }
    // eslint-disable-next-line
  }, [pageOffSet, sortOrder, selectedCollection]);

  useEffect(() => {
    let isThrottled = false;

    const handleScroll = () => {
      if (isThrottled || productData.length >= totalProducts || isFetchingMore)
        return;

      if (
        window.innerHeight + window.scrollY >=
        document.body.scrollHeight * 0.95 &&
        !isFetchingMore
      ) {
        isThrottled = true;
        setTimeout(() => (isThrottled = false), 300);
        setPageOffSet((prev) => prev + 1);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetchingMore, productData?.length, singleOrderData]);

  const filterProducts = () => {
    setProductData([]);
    setPageOffSet(1);
    getProducts();
  };
  const resetFilters = () => {
    isResetInProgress.current = true;
    setSendCustomData(false);

    const resetData = {
      DesgGroupNo: Number(id),
      CurrentPage: 1,
      PageSize: pageSize,
      SortOrder: 1,
      Status: "All",
      NetWtFrom: 0,
      NetWtTo: 250,
      DiamondWtFrom: 0,
      DiamondWtTo: 100,
    };

    setSelectedCollection(id ? [String(id)] : []);
    setSelectedCategory("");
    setProductData([]);
    setPageOffSet(1);
    setProductGram([0, 250]);
    setProductCarat([0, 100]);
    setSortOrder(1);

    getProducts(resetData);
    setTimeout(() => {
      isResetInProgress.current = false;
    }, 0);
  };

  return (
    <>
      <SEO titleTemplate="Category Page" description="Category Page" />
      <LayoutTwo>
        <div className="container">
          <ShopTopActionFilter
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            setFilterModal={setFilterModal}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedCollection={selectedCollection}
            setSelectedCollection={setSelectedCollection}
            productGram={productGram}
            setProductGram={setProductGram}
            productCarat={productCarat}
            setProductCarat={setProductCarat}
            setProductData={setProductData}
            setPageOffSet={setPageOffSet}
            filterProducts={filterProducts}
            resetFilters={resetFilters}
            sendCustomData={sendCustomData}
            setSendCustomData={setSendCustomData}
            getProducts={getProducts}
            pageOffSet={pageOffSet}
          />
          {(isLoadingData || isLoading || isLoadingSize) &&
            productData.length === 0 ? (
            <LoadingScreen />
          ) : productData.length === 0 ? (
            <div className="product_grid no_data">
              <div className="empty_icon_con">
                <img src={noDataImg} alt="NO Data Icon" />
                <p>No Data Found.</p>
              </div>
            </div>
          ) : (
            <div className="shop-bottom-area mt-30 mb-50">
              <section className="product_grid">
                {productData.map((product, index) => (
                  <React.Fragment key={index}>
                    <CategoryItem
                      product={product}
                      pageSize={pageSize}
                      prductSizeData={prductSizeData?.Data}
                    />
                  </React.Fragment>
                ))}
              </section>
              {isFetchingMore && <LoadingScreen />}
              {!isFetchingMore && !theKey && productData?.length >= 45 ? (
                <div className="product_login_section">
                  <img src={lockIcon} alt="lock" className="lock_icon" />
                  <h4>See More Designs</h4>
                  <p>
                    Join us to unlock our full collection of exclusive designs.
                  </p>
                  <div className="button_con">
                    <Link to="/login" className="button primary_btn">
                      Login
                    </Link>
                    <Link to="/register" className="button primary_btn">
                      Register
                    </Link>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          )}
        </div>
      </LayoutTwo>
      {filterModal && (
        <FilterModal
          show={filterModal}
          onHide={() => setFilterModal(false)}
          customFilterData={customFilterData}
          setCustomFilterData={setCustomFilterData}
          getProducts={getProducts}
          setProductData={setProductData}
          setPageOffSet={setPageOffSet}
          sendCustomData={sendCustomData}
          setSendCustomData={setSendCustomData}
        />
      )}
    </>
  );
};

export default Collection;
